import BookingsAffectedService from "app/services/bookingsAffected/bookingsAffected.service";

/**
 * Gets used on route 'settings.events.edit'
 */

import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";

import EventsService from 'app/services/events/events.service';
import EventsLookupService from "external-services/events-lookup-service";

const NS = 'EventsCtrl';

export default function EventsCtrl(
  $log, $rootScope, $scope, $state, $mdDialog, $filter, unregister
) {
  "ngInject";

  var vm = this;
  var toDelete;

  vm.sortBy = 'date';
  vm.sortReversed = true;
  vm.sortOptions = [{
    value: 'date',
    label: 'Date'
  }, {
    value: 'name',
    label: 'Name'
  }, {
    value: 'eventType',
    label: 'Type'
  }];
  vm.LOADING = 1;
  vm.LIST = 0;
  vm.CONFLICTS = 4;
  vm.state = vm.LOADING;
  vm.newEvent = newEvent;
  vm.deleteEvent = deleteEvent;
  vm.duplicateEvent = duplicateEvent;
  vm.editEvent = editEvent;
  vm.changeSortBy = changeSortBy;
  vm.changeSortDirection = changeSortDirection;
  vm.handleDeleteConfirmed = handleDeleteConfirmed;
  vm.handleDeleteCancelled = handleDeleteCancelled;
  vm.eventToDelete = null;
  vm.staffNameRequired = false;

  getEvents();

  //-- listen
  var listeners = [];
  listeners.push($scope.$watch('vm.searchStr', filterEvents));
  listeners.push($scope.$watch('vm.searchDate', filterEvents));
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));

  function changeSortDirection() {
    vm.sortReversed = !vm.sortReversed;
    changeOrder();
  }

  function changeSortBy() {
    vm.sortReversed = false;
    changeOrder();
  }

  function changeOrder() {
    vm.orderedEvents = $filter('orderBy')(vm.filteredEvents,
      function (eventObj) {
        if (vm.sortBy === 'eventType') {
          return eventObj[vm.sortBy] === '' ? 'event' : eventObj[vm.sortBy];
        }
        return eventObj[vm.sortBy] === '' ? 'zzzzzzz' : eventObj[vm.sortBy];
        /* The 'zzzzzz' forces the empty names to the end,
          I can't think of a simpler way at the moment. */
      }, vm.sortReversed);
  }

  function filterEvents() {
    var dateMatchRequired = (vm.searchDate && vm.searchDate instanceof Date);
    var queryMatchRequired = (vm.searchStr && vm.searchStr !== '');
    if (vm.events && (dateMatchRequired || queryMatchRequired) && vm.searchStr) {
      var lowercaseQuery = vm.searchStr.toLowerCase();
      var filterList = [];
      for (var i = vm.events.length - 1; i >= 0; i--) {
        var eventObj = vm.events[i];
        var querMatch = true;
        var dateMatch = true;
        if (queryMatchRequired) {
          querMatch = false;
          if (eventObj.name && eventObj.name.toLowerCase().indexOf(lowercaseQuery) !== -1) {
            querMatch = true;
          }
        }
        if (dateMatchRequired) {
          dateMatch = false;
          if ($filter('date')(eventObj.date, 'yyyy-MM-dd') === $filter('date')(vm.searchDate, 'yyyy-MM-dd')) {
            dateMatch = true;
          }
        }
        if (dateMatch && querMatch) {
          filterList.push(eventObj);
        }
      }
      vm.filteredEvents = filterList;
    } else {
      vm.filteredEvents = vm.events;
    }
    changeOrder();
  }

  function getEvents() {
    EventsLookupService.getAll().then(function (events) {
      vm.events = events;
      vm.filteredEvents = vm.events;
      if (vm.state !== vm.CONFLICTS) {
        vm.state = vm.LIST;
      }
      getGeneralSettings();
      changeOrder();
    }).catch(function (err) {
      $log.error('Events failed to load', err);
    });
  }

  function deleteEvent(evt, eventObj) {
    vm.eventToDelete = eventObj;
    vm.errorMessage = 'Delete Event ' + eventObj.name;
    vm.showDeleteConfirmation = true;
  }

  function reCheckConfict() {
    BookingsAffectedService.checkEvent(toDelete, null).then(function (effectedBookings) {
      vm.bookingConflicts = effectedBookings;
      filterConflicts();
    });
  }

  function filterConflicts() {
    if (vm.bookingConflicts && vm.bookingConflicts.length) {
      vm.timeConflicts = $filter('filter')(vm.bookingConflicts, {
        timeEffected: true
      });
      vm.tableConflicts = $filter('filter')(vm.bookingConflicts, {
        timeEffected: false
      });
      vm.serviceConflict = $filter('filter')(vm.bookingConflicts, {
        serviceEffected: false
      });
    } else {
      vm.timeConflicts = [];
      vm.tableConflicts = [];
      vm.serviceConflict = [];
    }
  }

  function getGeneralSettings()
  {
    GeneralSettingsService.get().then(function (settings) {

      if(settings.staffRequiredEditEvent != undefined)
      {
        if (vm.mode !== 'new') {
          vm.staffNameRequired = settings.staffRequiredEditEvent;
        }
      }

    });
  }

  function handleDeleteConfirmed(staffName)
  {

    vm.showDeleteConfirmation = false;
    // Removing Manju Changes done related to ChangeLog feature - NBI-4368-Removing-manju-changelog
    // let modifiedValue = populateLoggingObjectForDelete();

    EventsService.deleteEvent(vm.eventToDelete).then(function () {
      // Refresh list
      getEvents();
      // Check deleted event usage in bookings
      BookingsAffectedService.checkEvent(vm.eventToDelete, null).then(function (affectedBookings) {
        if (!affectedBookings || (affectedBookings.length === 0)) {
          // There are not conflicts
        } else {
          vm.state = vm.CONFLICTS;
          vm.bookingConflicts = affectedBookings;
          filterConflicts();
          listeners.push($rootScope.$on('booking-edited', reCheckConfict));
          listeners.push($rootScope.$on('booking-new', reCheckConfict));
        }
        // Removing Manju Changes done related to ChangeLog feature - NBI-4368-Removing-manju-changelog
        // ChangeLoggerService.save(modifiedValue, 'changelog_events', staffName, vm.eventToDelete.name);
      });
    });

       console.log("[EVENT UPDATE] - Updating changes");
  }

  // Removing Manju Changes done related to ChangeLog feature - NBI-4368-Removing-manju-changelog
  // function populateLoggingObjectForDelete()
  // {
  //   let modifiedValue = [];
  //
  //   modifiedValue.push(
  //     {
  //       property: 'Event',
  //       originalValue: vm.eventToDelete.name,
  //       newValue: '',
  //       operation: ChangeLogOperation.DeleteData
  //     }
  //   );
  //
  //   modifiedValue.push(
  //     {
  //       property: 'EventDate',
  //       originalValue: moment(vm.eventToDelete.date).format('DD MMM YY h:mma'),
  //       newValue: '',
  //       operation: ChangeLogOperation.DeleteData
  //     }
  //   );
  //
  //   if(vm.eventToDelete.firstName)
  //   {
  //     modifiedValue.push(
  //       {
  //         property: 'FirstName',
  //         originalValue: vm.eventToDelete.firstName,
  //         newValue: '',
  //         operation: ChangeLogOperation.DeleteData
  //       }
  //     );
  //   }
  //
  //   if(vm.eventToDelete.lastName)
  //   {
  //     modifiedValue.push(
  //       {
  //         property: 'LastName',
  //         originalValue: vm.eventToDelete.lastName,
  //         newValue: '',
  //         operation: ChangeLogOperation.DeleteData
  //       }
  //     );
  //   }
  //
  //   if (vm.eventToDelete.email) {
  //     modifiedValue.push(
  //       {
  //         property: 'EmailId',
  //         originalValue: vm.eventToDelete.email,
  //         newValue: '',
  //         operation: ChangeLogOperation.DeleteData
  //       }
  //     );
  //   }
  //
  //   if (vm.eventToDelete.people) {
  //     modifiedValue.push(
  //       {
  //         property: 'PAX',
  //         originalValue: vm.eventToDelete.people,
  //         newValue: '',
  //         operation: ChangeLogOperation.DeleteData
  //       }
  //     );
  //   }
  //
  //   if(vm.eventToDelete.paymentDetails)
  //     {
  //     modifiedValue.push(
  //       {
  //         property: 'PaymentType',
  //         originalValue: vm.eventToDelete.paymentDetails.paymentType,
  //         newValue: '',
  //         operation: ChangeLogOperation.DeleteData
  //       }
  //     );
  //
  //     if (vm.eventToDelete.paymentDetails.price) {
  //       modifiedValue.push(
  //         {
  //           property: 'Price',
  //           originalValue: vm.eventToDelete.paymentDetails.price,
  //           newValue: '',
  //           operation: ChangeLogOperation.DeleteData
  //         }
  //       );
  //     }
  //   }
  //
  //   if(vm.eventToDelete.paymentSummary)
  //     {
  //       modifiedValue.push(
  //         {
  //           property: 'AmountPaid',
  //           originalValue: vm.eventToDelete.paymentSummary.amountPaid,
  //           newValue: '',
  //           operation: ChangeLogOperation.DeleteData
  //         }
  //       );
  //
  //       modifiedValue.push(
  //         {
  //           property: 'PaymentDate',
  //           originalValue: moment(vm.eventToDelete.paymentSummary.paymentDate).format('DD MMM YY h:mma'),
  //           newValue: '',
  //           operation: ChangeLogOperation.DeleteData
  //         }
  //       );
  //
  //       modifiedValue.push(
  //         {
  //           property: 'PaymentId',
  //           originalValue: vm.eventToDelete.paymentSummary.transactionId,
  //           newValue: '',
  //           operation: ChangeLogOperation.DeleteData
  //         }
  //       );
  //     }
  //
  //     if(vm.timeConflicts && vm.timeConflicts.length > 0)
  //     {
  //       vm.timeConflicts.forEach(
  //         element => modifiedValue.push(
  //           {
  //             property: 'TimeConflict',
  //             originalValue: element,
  //             newValue: '',
  //             operation: ChangeLogOperation.DeleteData
  //           }
  //         )
  //       );
  //     }
  //
  //     if(vm.tableConflicts && vm.tableConflicts.length > 0)
  //     {
  //       vm.tableConflicts.forEach(
  //         element => modifiedValue.push(
  //           {
  //             property: 'TableConflict',
  //             originalValue: element,
  //             newValue: '',
  //             operation: ChangeLogOperation.DeleteData
  //           }
  //         )
  //       );
  //     }
  //
  //     if(vm.serviceConflict && vm.serviceConflict.length > 0)
  //     {
  //       vm.serviceConflict.forEach(
  //         element => modifiedValue.push(
  //           {
  //             property: 'ServiceConflict',
  //             originalValue: element,
  //             newValue: '',
  //             operation: ChangeLogOperation.DeleteData
  //           }
  //         )
  //       );
  //     }
  //
  //   return modifiedValue;
  // }

  function handleDeleteCancelled()
  {
    vm.showDeleteConfirmation = false ;
  }

  function newEvent() {
    $state.go('settings.events.edit', {
      id: 'new'
    });
  }

  function editEvent(event) {
    $state.go('settings.events.edit', {
      id: encodeURIComponent(event._id)
    });
  }

  function duplicateEvent(event) {
    $state.go('settings.events.duplicate', {
      id: encodeURIComponent(event._id)
    });
  }
}
